<template>
  <div id="overview">
    <div class="row">
      <div class="reportSection">
        <section-heading>
          <div slot="title">Overview</div>
        </section-heading>
        <left-column :company-overview="companyOverview" />
        <right-column :company-overview="companyOverview" />
      </div>
    </div>
    <div class="sectionBreak row"></div>
  </div>
</template>

<script>
import SectionHeading from '@/components/companies/components/SectionHeading';
import LeftColumn from './LeftColumn';
import RightColumn from './RightColumn';

export default {
  components: {
    LeftColumn,
    RightColumn,
    SectionHeading,
  },
  name: 'Overview',
  props: {
    companyOverview: {
      required: true,
      type: Object,
    },
  },
};
</script>

<style scoped></style>
